export const SIGN_IN = 'SIGN_IN'
export const SIGN_OUT = 'SIGN_OUT'
export const FETCH_ACCOUNTS = 'FETCH_ACCOUNTS'

export const fetchAccountsAction = (accounts) => {
  return {
    type: 'FETCH_ACCOUNTS',
    payload: accounts,
  }
}

export const signInAction = (userState) => {
  return {
    type: 'SIGN_IN',
    payload: {
      isSignedIn: true,
      uid: userState.uid,
      email: userState.email,
    },
  }
}

export const signOutAction = () => {
  return {
    type: 'SIGN_OUT',
    payload: {
      isSignedIn: true,
      uid: '',
      email: '',
    },
  }
}
